export default {
  TU: 'TU',
  EFX: 'EFX',
  XPN: 'XPN',
  EFX_PERSONALIZED: 'EFX_PERSONALIZED',
  EFX_ID_AUTH_NEIGHBOURHOOD_CREDIT: 'EFX_ID_AUTH_NEIGHBOURHOOD_CREDIT',
};
